import { render, staticRenderFns } from "./CreateEmail.vue?vue&type=template&id=dce84a44&"
import script from "./CreateEmail.vue?vue&type=script&lang=js&"
export * from "./CreateEmail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dce84a44')) {
      api.createRecord('dce84a44', component.options)
    } else {
      api.reload('dce84a44', component.options)
    }
    module.hot.accept("./CreateEmail.vue?vue&type=template&id=dce84a44&", function () {
      api.rerender('dce84a44', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Services/Hosting/Shared/Email/Accounts/CreateEmail.vue"
export default component.exports